function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 1C6.376 1 1 6.376 1 13C1 19.624 6.376 25 13 25C19.624 25 25 19.624 25 13C25 6.376 19.624 1 13 1Z",
  stroke: "#A0A0A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.97293 18.4717C6.71933 18.8539 6.28138 19.3242 6.0472 19.5663C5.97789 19.6379 6.01112 19.7575 6.1084 19.7793C6.87881 19.9525 9.49356 20.4573 11.0246 19.7272C12.0741 19.2267 12.3708 18.5047 13.3073 17.8155C14.5202 16.9229 15.6436 16.9623 16.5886 15.7896C17.302 14.9043 17.1562 14.0821 17.7869 13.1361C18.4123 12.198 19.2411 12.0277 19.7557 11.0246C20.5222 9.53053 19.8861 6.94084 19.658 6.13514C19.6291 6.03303 19.4958 6.01236 19.4316 6.09685C19.2266 6.36664 18.8482 6.83253 18.5003 7.08706C17.7324 7.64883 16.9459 7.28087 16.1891 7.85745C15.1426 8.65477 15.6649 9.98183 14.7054 10.8819C13.9964 11.547 13.2278 11.3982 12.5083 12.0518C11.6865 12.7984 11.8453 13.7293 11.0246 14.4771C10.0729 15.3443 8.86317 14.8341 8.00011 15.7896C7.24829 16.622 7.59312 17.5372 6.97293 18.4717Z",
  stroke: "#A0A0A0",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2852 10.5278C17.9041 11.1158 17.3371 11.188 17.0697 11.0147C16.8022 10.8413 16.6363 10.2944 17.0173 9.70631C17.3983 9.11825 17.9653 9.04611 18.2328 9.21942C18.5003 9.39273 18.6662 9.93971 18.2852 10.5278Z",
  stroke: "#A0A0A0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5323 14.9357C14.2647 15.2504 13.9415 15.4402 13.6537 15.5087C13.3655 15.5774 13.1509 15.5203 13.0179 15.4072C12.8849 15.2942 12.7941 15.0916 12.8155 14.7961C12.8369 14.501 12.9721 14.1514 13.2397 13.8367C13.5073 13.522 13.8306 13.3322 14.1184 13.2637C14.4066 13.195 14.6211 13.252 14.7541 13.3651C14.8871 13.4782 14.9779 13.6808 14.9565 13.9763C14.9352 14.2713 14.7999 14.6209 14.5323 14.9357Z",
  stroke: "#A0A0A0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4997 18.0366C10.181 18.2202 9.85489 18.2812 9.59736 18.2528C9.33944 18.2244 9.18748 18.1153 9.11687 17.9928C9.04627 17.8702 9.0281 17.684 9.13291 17.4467C9.23756 17.2097 9.45387 16.9581 9.77263 16.7745C10.0914 16.5908 10.4175 16.5299 10.675 16.5582C10.9329 16.5866 11.0849 16.6957 11.1555 16.8183C11.2261 16.9408 11.2443 17.127 11.1395 17.3644C11.0348 17.6014 10.8185 17.8529 10.4997 18.0366Z",
  stroke: "#A0A0A0"
});

function SvgSoyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoyIcon);
export default __webpack_public_path__ + "static/media/SoyIcon.4c2e6304.svg";
export { ForwardRef as ReactComponent };